import { isEnumControl, rankWith } from '@jsonforms/core';
import { withJsonFormsControlProps } from '@jsonforms/react';
import { get } from 'lodash';
import { currencyFormat } from '../../../../../utils/currency';
import {
  currencySymbol,
  getActions,
} from '../../../../../utils/DynamicForms';
import { FormItem } from '../../../../../controls/FormItem';
import { Select } from '../../../../../controls/Select';
import { useDynamicFormContext } from '../../../DynamicFormContext';
import { FieldProps, WithDynamicFormContext } from '../WithDynamicFormContext';
import './style.scss';

const SelectControl = ({
  path,
  label,
  schema,
  handleChange,
  handleRemove,
  handleBlur,
  data,
  required,
  uischema,
  formData,
  disabled,
  optionalMessage,
}: FieldProps) => {
  const currency = currencySymbol(
    formData,
    uischema.options?.dependencies?.[0],
  );
  const { options } = uischema;
  const moreInfo = uischema.options?.moreInfo;
  const labelClass = uischema.options?.labelClass;
  const { handleActions } = useDynamicFormContext();
  const actions = getActions(uischema);
  const removedPaths = uischema?.options?.removedPaths;
  let dependentPath = uischema.options?.dependentPath;
  const acceptedValues = uischema.options?.acceptedValues;
  const dependentValData = get(formData, dependentPath);
  const changePath = uischema.options?.changePath;
  
  if (acceptedValues && !acceptedValues?.includes(+dependentValData))
    dependentPath = false;

  const handleClick = () => {
    if (actions?.length) handleActions(actions);
    handleBlur(path);
  };


  return (
    <FormItem
      label={label as string}
      required={required}
      classes="tru-select-input-control"
      moreInfo={moreInfo}
      labelClass={labelClass}
      optionalMessage={optionalMessage}
    >
      <div>
        <div className={dependentPath ? 'select-text-wrapper' : ''}>
          <Select
            onBlur={handleClick}
            value={data || ''}
            disabled={disabled}
            onChange={(value) => {
              if (schema.type === 'number') {
                handleChange(path, Number(value));
              } else {
                if (!!value) {
                  handleChange(path, value);
                } else {
                  handleRemove(path);
                }
              }
              if (changePath) {
                handleChange(
                  changePath,
                  true,
                );
              }
              if (dependentPath && dependentValData)
                handleChange(dependentPath, Number(value));

              if (removedPaths)
                removedPaths.forEach((element: string) => {
                  handleRemove(element);
                });
            }}
          >
            {schema.enum?.map((opt) => (
              <option key={`select-option-${opt}`} value={opt}>
                {options?.currency
                  ? currencyFormat(Number(opt), currency)
                  : opt}
              </option>
            ))}
          </Select>
          {dependentPath && (
            <span className="text-with-select">
              {' '}
              {currencyFormat(dependentValData)}{' '}
            </span>
          )}
          {schema.description && (
            <p className="description margin-bottom">{schema.description}</p>
          )}
        </div>
      </div>
    </FormItem>
  );
};

export const SelectControlEntry = {
  tester: rankWith(3, isEnumControl),
  renderer: withJsonFormsControlProps(WithDynamicFormContext(SelectControl)),
};
